<template>
  <div ref="container" class="preview__container">
    <img ref="imgcontainer" :src="imgUrl" class="preview__img" alt="预览图片" @wheel.passive="wheelEvent" />
    <div v-if="imageShow" class="scale">
      {{ scalePercent }}
    </div>
  </div>
</template>

<script>
import { mat4 } from "gl-matrix";
export default {
  props: {
    imgUrl: {
      required: true
    }
  },
  data: () => {
    return {
      /** 初始缩放比例 100% */
      scale: 1,
      /** 初始x轴偏移距离 0 */
      xBias: 0,
      /** 初始y轴偏移距离 0 */
      yBias: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      initialClientX: null,
      currentClientx: null,
      imageShow: false
    };
  },
  computed: {
    scalePercent() {
      const { currentClientx, initialClientX } = this;
      if (!currentClientx || !initialClientX) return "100%";
      return ((currentClientx / initialClientX) * 100).toFixed(0) + "%";
    },
    /** 缩放矩阵 */
    scaleMatrix() {
      const { scale } = this;
      return new Float32Array([scale, 0, 0, 0, 0, scale, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
    },
    /** 平移矩阵 */
    translationMatrix() {
      const { xBias: x, yBias: y } = this;
      return new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, x, y, 0, 1]);
    },
    /** 坐标矩阵 */
    coordinateMatrix() {
      const { left, top, right, bottom } = this;
      /** 二维坐标映射为4维矩阵 */
      return new Float32Array([left, top, 1, 1, right, top, 1, 1, right, bottom, 1, 1, left, bottom, 1, 1]);
    }
  },
  methods: {
    wheelEvent(event) {
      this.imageShow = true;
      if (!this.$refs["imgcontainer"]) {
        this.$nextTick(() => this.wheelEvent(event));
        return;
      }
      const { clientX, clientY, deltaY } = event;
      let scale = 1 + (deltaY < 0 ? 0.1 : -0.1);
      /** 最低缩放比例 10% */
      scale = Math.max(scale > 0 ? scale : 1, 0.1);
      this.scale = scale;

      const { top, right, bottom, left } = this.$refs["imgcontainer"].getBoundingClientRect();

      this.initialClientX == null ? (this.initialClientX = right - left) : "";
      this.currentClientx = right - left;
      Object.assign(this, { top, right, bottom, left });
      console.log(this.scale);
      this.xBias = clientX * (1 - this.scale);
      this.yBias = clientY * (1 - this.scale);
      const scaleResult = mat4.multiply(new Float32Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), this.scaleMatrix, this.coordinateMatrix);
      const transResult = mat4.multiply(new Float32Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), this.translationMatrix, scaleResult);
      this.$refs["imgcontainer"].setAttribute(
        "style",
        `left: ${transResult[0]}px;
                 top: ${transResult[1]}px;
                 width: ${transResult[4] - transResult[0]}px;
                 height: ${transResult[9] - transResult[1]}px;
                 transform: translate(0,0);
                `
      );
      setTimeout(() => {
        this.imageShow = false;
      }, 1500);
    }
  }
};
</script>

<style lang="scss">
.preview__container {
  height: 100%;
  width: 100%;
  position: relative;
}
.preview__img {
  position: absolute;
  width: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.scale {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  padding: 3px;
  background-color: #000;
  border-radius: 3px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
</style>
